/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable arrow-parens */
import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Header = styled.header`
  width: 90%;
  height: 70px;
  background: #fff;
  margin-left: 1.5%;
  border-radius: 10px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

export const ButtonTest = styled.button`
  background: none;
  border: 0;
  position: relative;
  ${(props) =>
    props.selected &&
    css`
      background: #090f35;
      width: 180px;
      height: 70px;
      color: #fff;
    `}
`;

export const Container = styled.div`
  width: 88%;
  background: #fff;

  margin-top: 10px;
  margin-left: 2.5%;

  padding: 20px;

  h1 {
    margin-bottom: 40px;
  }

  h2 {
    padding-left: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  h3 {
    padding-left: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  h4 {
    padding-left: 30px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  p,
  a {
    padding-left: 40px;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  form {
    div.select {
      p {
        font-size: 20px;
        padding: 0;
      }
      select {
        height: 50px;
        width: 300px;
      }
    }
  }

  div.support {
    /* display: grid; */

    justify-content: center;
  }

  input {
    background: rgba(0, 0, 0, 0.1);
    border: 1px solid #090f35;
    border-radius: 5px;
    box-sizing: border-box;
    height: 50px;
    width: 300px;
    padding: 0 15px;
    color: #090f35;
    margin: 20px 10px 0;

    &::placeholder {
      color: #090f35;
    }
  }

  input:focus {
    border: 2px solid #36ded6;
  }

  button.form {
    margin: 60px 35% 0;
    height: 50px;
    width: 360px;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 14px;
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  background: #eee;
  padding: 20px;
  margin: 10px auto;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  div.title {
    width: 300px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  div.description {
    width: 700px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  div.button {
    width: 100px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }

  button.row {
    background: none;
    border: 0;
    margin: 0 10px;
  }
`;
